<template>
	<div class="knob-arrow" :class="{ 'is-open': isOpen }">
		<svg xmlns="http://www.w3.org/2000/svg" width="10.925" height="8.638" viewBox="0 0 10.925 8.638">
			<line
				x2="9.287"
				transform="translate(10.037 4.362) rotate(180)"
				fill="none"
				stroke="#6d7f93"
				stroke-linecap="round"
				stroke-width="1.5"
			/>
			<path
				d="M0,0,3.259,3.06,6.518,0"
				transform="translate(7.115 7.578) rotate(-90)"
				fill="none"
				stroke="#6d7f93"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-miterlimit="10"
				stroke-width="1.5"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'KnobArrow',
	props: {
		isOpen: { type: Boolean },
	},
};
</script>

<style scoped lang="scss">
.knob-arrow {
	pointer-events: none;

	&.is-open {
		transform: rotate(0deg);
		transition: 0.5s;
	}
	&:not(.is-open) {
		transform: rotate(180deg);
		transition: 0.5s;
	}
}
</style>
